/** URL scheme: voice.akrsmv.net/#s/<sessionId> for per-session addressability */

export function buildSessionHash(sessionId: string): string {
  return '#s/' + sessionId;
}

/** Returns sessionId from '#s/<id>' hash, or null if not a session URL */
export function parseSessionHash(hash: string): string | null {
  if (!hash.startsWith('#s/')) return null;
  const id = hash.slice(3);
  return id.length > 0 ? id : null;
}
